/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stock_Out_Material_Section_TitleInputs */

const vi_stock_out_material_section_title = /** @type {(inputs: Stock_Out_Material_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vật tư`)
};

/**

* @param {Stock_Out_Material_Section_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stock_out_material_section_title = /** @type {((inputs?: Stock_Out_Material_Section_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stock_Out_Material_Section_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stock_out_material_section_title(inputs)
});